import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RoutePathEnum } from '@connect-services/client/models/routes.model';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-login-container',
    styleUrl: './login-container.component.scss',
    templateUrl: './login-container.component.html',
})
export class LoginContainerComponent {
    public readonly hasBackNavigationButton = input<boolean>(false);
    public readonly subtitleI18NKey = input<string>('');

    protected readonly RoutePathEnum = RoutePathEnum;
}
